import React from "react";

import Image from "../../components/image";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { DesktopTabletOnly, MobileOnly } from "../base/wrapper/device";

const HomeBanner = ({
  heroTitle,
  heroDesc,
  mobileDesc,
  heroCTATitle,
  videoId,
  featureVideoId,
  heroImage,
  heroGatsbyImage,
  heroImageMobile,
  heroGatsbyImageMobile
}) => {
  const breakpoint = useBreakpoint();

  return (
    <>
      <section className="flex flex-col items-center justify-center px-2 py-8 sm:py-0 mx-auto bg-cover bg-no-repeat bg-center hero-section relative dark:gvi-dark-gray-bg bg-yellow-standard">
        {heroImage && (
          <div className="absolute top-0 right-0 left-0 bottom-0 z-0">
            <MobileOnly>
              <Image
                imageAlt={""}
                image={heroGatsbyImageMobile}
                imageClass="mobile-hero absolute z-0 object-cover object-right w-full h-full sm:hidden"
                sourceUrl={[
                  "https://assets.gviworld.com/cdn-cgi/image/gravity=0.5x0.5,brightness=.8,format=auto,trim=0;150;0;800,quality=100/",
                  heroImageMobile
                ].join("")}
              />
            </MobileOnly>
            <DesktopTabletOnly>
              <Image
                imageAlt={""}
                image={heroGatsbyImage}
                imageClass="home-desktop-hero absolute z-0 object-cover w-full h-full object-center hidden sm:block"
                sourceUrl={heroImage}
              />
            </DesktopTabletOnly>
          </div>
        )}
        <div className="container w-full sm:w-10/12 absolute z-0">
          <div className="flex flex-col sm:flex-row">
            <div className="px-6 md:px-0 w-full sm:w-1/2">
              <h1
                className="!text-left heading-highlight dark:heading-highlight"
                dangerouslySetInnerHTML={{ __html: heroTitle }}
              />
              <div className="banner-description py-6 w-full md:w-11/12">
                <div
                  className="text-base leading-6 text-white pb-6"
                  dangerouslySetInnerHTML={{
                    __html:
                      breakpoint && breakpoint !== "xs" ? heroDesc : mobileDesc
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeBanner;
